import ApplicationAdapter from './application';

export default class CustomerSegmentAdapter extends ApplicationAdapter {
  buildURL(modelName, id, snapshot, requestType, query) {
    return super.buildURL('segment', id, snapshot, requestType, query);
  }
}
